"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SurveyTriggerType=void 0;var r;(function(e){e.Auto="auto",e.Customer="customer"})(r||(exports.SurveyTriggerType=r={}));
//# sourceMappingURL=SurveyTriggerType.js.map
